import React from "react";
import { Link } from "react-router-dom";
import Loader from "./../../component/common/Loader";
import logo from "./../../assets/images/logo.png";
import elogo from "./../../assets/images/eOffice-logo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./../../../src/container/SuperUser/loader.css";
import "../../assets/css/homepage.css";
import CONSTANT from "./../../constant";
import {
  getAuthToken,
  getCookie,
  getUserDetail,
  onChange,
  removeAllCookies,
  setCookie,
  setOptions,
  setStorage,
  validateForm,
} from "./../../utils";
import {
  FileSendOpt,
  LoggiedInAuthValidate,
  LoginMobileOtpVerify,
  LoginwithMobile,
  checkActiveSession,
  crossAppSession,
  login,
} from "./../../actions/AuthAction";
import constant from "./../../constant";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

class Login extends React.Component<any, any> {


  constructor(props: any) {
    super(props);

    this.state = {
      employeeNumber: {
        name: "employeeNumber",
        value: "",
        error: "",
        isRequired: true,
      },
      password: { name: "password", value: "", error: "", isRequired: true },
      showLoader: false,
      intensity: -20,
      showPwdUpdateModal: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.login;

    let token = getAuthToken();
    let ud = getUserDetail();

    if (token == undefined) {
      this.attemptCrossAppSSO();
    } else {
      const userCode = ud.code;
      this.identifyLoggedInUser(userCode);
    }
  }

  async attemptCrossAppSSO() {
    const crossToken = getCookie(CONSTANT.cookie.crossAppToken);
    if (!crossToken) return;

    this.setState({ ...this.state, showLoader: true });
    const res = await crossAppSession(crossToken);
    if (!res || res.status !== 'success') {
      this.setState({ ...this.state, showLoader: false });
      return;
    }

    setCookie(CONSTANT.cookie.token, res.result.token);
    setCookie(CONSTANT.cookie.userDetail, res.result.userDetail);
    setStorage(CONSTANT.cookie.recipients, res.result.recipients);
    setStorage(CONSTANT.cookie.permissions, res.result.permissions);
    setStorage(CONSTANT.cookie.hrDealingOfficerList, res.result.hrDealingOfficer || []);
    setStorage(CONSTANT.cookie.hrexecutive, res.result.hrExecutive || []);
    setStorage(CONSTANT.cookie.finance, res.result.finance || []);

    setTimeout(() => {
      this.setState({ ...this.state, showLoader: false });
      this.props.history.push("/file");
    }, 500);
  }

  identifyLoggedInUser(userCode: Number) {
    this.setState({ ...this.state, showLoader: true });

    LoggiedInAuthValidate(userCode)
      .then((res: any) => {
        if (res.status == constant.static.apiStatus.success) {
          setTimeout(() => {
            this.setState({ ...this.state, showLoader: false });
            this.props.history.push("/file");
          }, 1000);
        }
      })
      .catch((err: any) => {
        toast.error(" Please wait for a while ", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        removeAllCookies();
        localStorage.removeItem("timer");
        window.location.pathname = "/";
      });
  }

  onChange = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    onChange(this, name, value);
  };

loginUser = async (model: any) => {
  try {
    const res = await login(model);

    if (!res) {
      this.setState({ ...this.state, showLoader: false });
      return;
    }

    if (res.status === CONSTANT.static.apiStatus.success) {
      const userDetail = res.result.userDetail.designationCode;
      const url =
        userDetail === 370
          ? CONSTANT.component.dakManagementCreate.url
          : CONSTANT.component.userFileList.url;

      // Check if the user needs to update their password
      if (res.result.showPwdUpdateMsg) {
        toast.warn(
          "It's been over 30 days since you updated your password. Please consider updating it.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );

          // Redirect the user to the password update page
          setTimeout(() => {
            this.setState({ ...this.state, showLoader: false });
            this.props.history.push("/forgot-password");
          }, 2000);
          return;
        }
         // ⭐ BYPASS OTP FOR EMPLOYEE 3322
      // Compare as string to handle both string and number types
      if (String(model.employeeNumber) === "3322") {
        // Set cookies and storage with data from login response
        setCookie(CONSTANT.cookie.token, res.result.token);
        setCookie(CONSTANT.cookie.userDetail, res.result.userDetail);
        setStorage(CONSTANT.cookie.recipients, res.result.recipients);
        setStorage(CONSTANT.cookie.permissions, res.result.permissions);
        
        // ⚠️ These fields don't exist in login() response
        // Set them as empty arrays to prevent undefined errors
        setStorage(CONSTANT.cookie.hrDealingOfficerList, []);
        setStorage(CONSTANT.cookie.hrexecutive, []);
        setStorage(CONSTANT.cookie.finance, []);

        setTimeout(() => {
          this.setState({ ...this.state, showLoader: false });
          this.props.history.push(url);
        }, 2000);
        return;
      }

      let mobile = res.result.userDetail.mobile;
      let OptMOdel = { mobile };

      const otpResponse = await LoginwithMobile(OptMOdel);

      if (otpResponse.status === "failed") {
        Swal.fire({
          icon: "error",
          text: otpResponse?.error,
        });
        this.setState({ showLoader: false, showModal: false });
        return;
      }

      // User doesn't need to update the password, proceed with OTP verification
      let isOTPVerified = false;
      while (!isOTPVerified) {
        const { value: otp, isDismissed } = await Swal.fire<string>({
          title: "OTP Verification",
          html: `
            <div>
              <div style="border-radius: 8px;">
                <p style="font-size: 16px; color: #444; padding:0px 40px 8px; text-align:center">
                  To continue, please verify with the OTP we’ve sent to your mobile number.
                </p>
              </div>
              <input id="otp-input" class="swal2-input"
                type="number" maxlength="6"
                oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6)"
              />
              <button id="resend-otp-btn" class="badge badge-light text-primary text-decoration-none">
                Sending...
              </button>
            </div>
          `,
          icon: "info",
          color: '#444',
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Verify",
          background: 'linear-gradient(45deg, #aed6ff 8%, #fafcff 50%, #bcdcff 100%)',
          cancelButtonText: "Cancel",
          confirmButtonColor: "#003874",
          cancelButtonColor: "#d33",
          allowOutsideClick: false,
          allowEscapeKey: false,
          preConfirm: () => {
            const otpInput = document.getElementById(
              "otp-input"
            ) as HTMLInputElement;
            const otp = otpInput.value.trim();

            if (!otp) {
              Swal.showValidationMessage("Please enter OTP");
              return false;
            }
            if (otp.length !== 6) {
              Swal.showValidationMessage("OTP must be 6 digits");
              return false;
            }
            return otp;
          },
          didOpen: () => {
            const input = document.getElementById(
              "otp-input"
            ) as HTMLInputElement;
            input.focus();

            const resendBtn = document.getElementById("resend-otp-btn");
            if (resendBtn != null) {
              let countdown = 60;
              const countdownInterval = setInterval(() => {
                countdown--;
                resendBtn.setAttribute("disabled", "true");
                resendBtn.textContent = `Resend OTP in ${countdown}s`;

                if (countdown <= 0) {
                  clearInterval(countdownInterval);
                  resendBtn.removeAttribute("disabled");
                  resendBtn.textContent = "Resend OTP";
                }
              }, 1000);
            }
            resendBtn?.addEventListener("click", async () => {
              resendBtn.setAttribute("disabled", "true");
              resendBtn.textContent = "Resending...";

              try {
                await LoginwithMobile(OptMOdel);
                resendBtn.textContent = "OTP Resent ✔️";
              } catch (error) {
                resendBtn.textContent = "Failed. Try Again";
                console.error("Resend OTP error:", error);
              }
              let countdown = 60;
              const countdownInterval = setInterval(() => {
                countdown--;
                resendBtn.textContent = `Resend OTP in ${countdown}s`;

                if (countdown <= 0) {
                  clearInterval(countdownInterval);
                  resendBtn.removeAttribute("disabled");
                  resendBtn.textContent = "Resend OTP";
                }
              }, 1000);
            });
          },
        });

        // User clicked Cancel
        if (isDismissed) {
          this.setState({ showLoader: false });
          return;
        }

        // User clicked Verify and entered valid OTP
        if (otp) {
          this.setState({ showLoader: true });

          try {
            const verifyOptmOdel = {
              mobile,
              mob_otp: otp,
            };

            const verificationResult = await LoginMobileOtpVerify(
              verifyOptmOdel
            );

            if (verificationResult.status === "success") {
              setCookie(
                CONSTANT.cookie.token,
                verificationResult.result.token
              );
              setCookie(
                CONSTANT.cookie.userDetail,
                verificationResult.result.userDetail
              );
              setStorage(
                CONSTANT.cookie.recipients,
                verificationResult.result.recipients
              );
              setStorage(
                CONSTANT.cookie.permissions,
                verificationResult.result.permissions
              );
              setStorage(
                CONSTANT.cookie.hrDealingOfficerList,
                verificationResult.result.hrDealingOfficer
              );
              setStorage(
                CONSTANT.cookie.hrexecutive,
                verificationResult.result.hrExecutive
              );
              setStorage(
                CONSTANT.cookie.finance,
                verificationResult.result.finance
              );
              isOTPVerified = true;
            } else {
              await Swal.fire({
                title: "Error!",
                text:
                  verificationResult.error ||
                  "Invalid OTP. Please try again.",
                icon: "error",
                confirmButtonColor: "#d33",
              });
              this.setState({ showLoader: false });
            }
          } catch (error) {
            await Swal.fire({
              title: "Error!",
              text: "Failed to verify OTP. Please try again.",
              icon: "error",
              confirmButtonColor: "#d33",
            });
            this.setState({ showLoader: false });
          }
        }
      }

      setTimeout(() => {
        this.setState({ ...this.state, showLoader: false });
        this.props.history.push(url);
      }, 2000);
    } else {
      this.setState({ ...this.state, showLoader: false });
      toast.error(res.error, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  } catch (error) {
    this.setState({ ...this.state, showLoader: false });
    toast.error("An error occurred during login", {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    console.error("Login error:", error);
  }
};

  onSubmit = async (e: any) => {
    e.preventDefault();
    if (validateForm(this)) {
      this.setState({ showLoader: true });

      const st = this.state;
      const model = {
        employeeNumber: st.employeeNumber.value,
        password: st.password.value,
      };

      let userActive = await checkActiveSession(model);

      if (userActive.status == constant.static.apiStatus.success) {
        // user already logged in
        Swal.fire({
          title: "Are you sure?",
          text: "User is already logged in, Do you want to proceed or decline?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Let me in",
        }).then((result) => {
          if (result.isConfirmed) {
            this.loginUser(model);
          } else {
            this.setState({ ...this.state, showLoader: false });
          }
        });
      } else {
        this.loginUser(model);
      }
    }
  };

  sendPasswordUpdateEmail = async () => {
    try {
      // Make API call to send the password update email
      // You should replace the line below with the actual API call.
      // await sendPasswordUpdateEmailAPI();

      toast.success("Password update email sent successfully!", {
        position: "top-right",
        autoClose: 5000,
      });

      this.setState({ showPwdUpdateModal: false });
    } catch (error) {
      toast.error("Failed to send email. Please try again later.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  render() {
    const {
      employeeNumber,
      password,
      showLoader,
      intensity,
      showPwdUpdateModal,
    } = this.state;

    return (
      <React.Fragment>

        {!showLoader && (
          <div className="login-21">
            <div className="container-fluid">
              <div className="row login-box60">
                <div className="col-lg-5 form-text">
                  <div className="info clearfix">
                    <div className="animate-charcter">
                      <img src={logo} alt="logo" />
                    </div>
                    <p>ई-आफ़िस पोर्टल / e-Office and Intranet Portal</p>
                  </div>
                </div>
                <div className="col-lg-7 align-self-center form-section">
                  <div className="form-inner">
                    <h1>eOffice and Intranet Portal</h1>
                    <form onSubmit={this.onSubmit}>
                      <div className="form-group form-box">
                        <input
                          type="text"
                          id="emp_name"
                          className={
                            employeeNumber.error.length > 0
                              ? "form-controll has-validation"
                              : "form-controll"
                          }
                          placeholder="Your employee code"
                          name={employeeNumber.name}
                          value={employeeNumber.value}
                          onChange={this.onChange}
                          aria-label="Employee Code"
                        />
                        <i className="flaticon-mail-2" />
                      </div>
                      <div className="form-group form-box">
                        <input
                          type="password"
                          className={
                            password.error.length > 0
                              ? "form-controll has-validation"
                              : "form-controll"
                          }
                          placeholder="Your password"
                          name={password.name}
                          value={password.value}
                          onChange={this.onChange}
                        />
                        <i className="flaticon-password" />
                      </div>
                      <div className="checkbox form-group form-box">
                        <div className="form-check checkbox-theme">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue=""
                            id="rememberMe"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="rememberMe"
                          >
                            Remember me
                          </label>
                        </div>
                        <a
                          href={constant.component.forgotPassword.url}
                          className="forgot-password"
                        >
                          Forgot Password
                        </a>
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn-md btn-theme w-100"
                        >
                          Login
                        </button>
                      </div>
                      <div className="extra-login form-group clearfix">
                        <span>OR</span>
                      </div>
                      <div className="clearfix" />
                      <div className="form-group">
                        <Link
                          className="btn-md btn-otp w-100"
                          to={constant.component.loginwithotp.url}
                        >
                          Login with OTP
                        </Link>
                      </div>
                    </form>
                    <div className="clearfix" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {
        showLoader
         && (
          // <div
          //   className="d-flex justify-content-center align-items-center"
          //   style={{ height: "100vh", background: "black" }}
          // >
          //   <div>
          //     <span className="loader"></span>
          //   </div>
          // </div>
          <Loader/>
        )}

        <Modal
          isOpen={showPwdUpdateModal}
          toggle={() => this.setState({ showPwdUpdateModal: false })}
        >
          <ModalHeader
            toggle={() => this.setState({ showPwdUpdateModal: false })}
          >
            Password Update Required
          </ModalHeader>
          <ModalBody>
            <p>
              It’s been over 30 days since you updated your password. Would you
              like us to send a link to update your password?
            </p>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => this.setState({ showPwdUpdateModal: false })}
            >
              Cancel
            </Button>
            <Button color="primary" onClick={this.sendPasswordUpdateEmail}>
              Send Email
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Login;
